import * as React from 'react';
import type { FeedFilter } from '../types';

type FeedFiltersProps = {
  filters: FeedFilter[];
  activeId: string;
  onSelect: (filter: FeedFilter) => void;
};

export function FeedFilters({ filters, activeId, onSelect }: FeedFiltersProps) {
  const listRef = React.useRef<HTMLDivElement>(null);
  // On phones the chip row scrolls sideways. A fade on the right edge shows
  // there are more chips; it goes away once the row is scrolled to the end.
  const [moreRight, setMoreRight] = React.useState(false);

  const measure = React.useCallback(() => {
    const el = listRef.current;
    if (!el) return;
    setMoreRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 2);
  }, []);

  React.useEffect(() => {
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [measure, filters.length]);

  return (
    <div
      ref={listRef}
      className={`activity-dashboard__filters${moreRight ? ' has-more-right' : ''}`}
      role="tablist"
      aria-label="Activity filters"
      onScroll={measure}
    >
      {filters.map((filter) => {
        const active = filter.id === activeId;
        return (
          <button
            key={filter.id}
            type="button"
            role="tab"
            aria-selected={active}
            className={`activity-chip${active ? ' is-active' : ''}`}
            onClick={() => onSelect(filter)}
          >
            {filter.label}
          </button>
        );
      })}
    </div>
  );
}
